import { stringify } from 'querystringify';
import { combineReducers } from 'redux';
import { put, takeEvery } from 'redux-saga/effects';
import prepareBody from '../utils/prepareBody';
import { selectPlanId, selectRunnerId } from './auth';
import { CLOSE_MODAL as CLOSE_COMPLTED_MODAL, openNewSignupModal } from './completed';


export const CHANGE_FIELD = 'feedback/CHANGE_FIELD';
export const SKIP_FEEDBACK = 'feedback/SKIP_FEEDBACK';
export const SEND_FEEDBACK = 'feedback/SEND_FEEDBACK';
export const SEND_FEEDBACK_SUCCESS = 'feedback/SEND_FEEDBACK_SUCCESS';
export const SEND_FEEDBACK_FAILURE = 'feedback/SEND_FEEDBACK_FAILURE';
export const SEND_API_FEEDBACK = 'feedback/SEND_API_FEEDBACK';
export const SEND_API_FEEDBACK_SUCCESS = 'feedback/SEND_API_FEEDBACK_SUCCESS';
export const SEND_API_FEEDBACK_FAILURE = 'feedback/SEND_API_FEEDBACK_FAILURE';

const formAction = 'https://docs.google.com/forms/d/e/1FAIpQLSebANlwXmlY3J4LZ0dRUKY9emXesuFeVeXPjGHaoz2xZOvtIg/formResponse';
const planExperience = 'entry.918335094';
const useInFuture = 'entry.328489210';
const pleasedWithFinishTime = 'entry.557859098';
const personalBest = 'entry.1699676724';
const comments = 'entry.1652980671';

const trainingExperienceMap = {
    'Not Satisfied': 2,
    'Somewhat Satisfied': 3,
    Satisfied: 4,
    'Very Satisfied': 5,
};

export const fields = (state = {
    planExperience: null,
    useInFuture: null,
    pleasedWithFinishTime: null,
    personalBest: null,
    comments: '',
}, action) => {
    switch (action.type) {
        case CHANGE_FIELD:
            return {
                ...state,
                [action.key]: action.val,
            };
        default:
            return state;
    }
};

export const loading = (state = false, action) => {
    switch (action.type) {
        case SEND_FEEDBACK:
            return true;
        case SEND_FEEDBACK_FAILURE:
        case SEND_FEEDBACK_SUCCESS:
            return false;
        default:
            return state;
    }
};

export const loadingApi = (state = false, action) => {
    switch (action.type) {
        case SEND_API_FEEDBACK:
            return true;
        case SEND_API_FEEDBACK_FAILURE:
        case SEND_API_FEEDBACK_SUCCESS:
            return false;
        default:
            return state;
    }
};

export const open = (state = false, action) => {
    switch (action.type) {
        case CLOSE_COMPLTED_MODAL:
            return true;
        case SEND_API_FEEDBACK_FAILURE:
        case SEND_API_FEEDBACK_SUCCESS:
        case SKIP_FEEDBACK:
            return false;
        default:
            return state;
    }
};

export const finishedRace = (state = true, action) => {
    switch (action.type) {
        case CLOSE_COMPLTED_MODAL:
            return action.finished;
        default:
            return state;
    }
};

export default combineReducers({ fields, loading, open, loadingApi, finishedRace });

export const sendFeedback = (data) => {
    const body = {
        [planExperience]: data.planExperience,
        [useInFuture]: data.useInFuture,
        [pleasedWithFinishTime]: data.pleasedWithFinishTime,
        [personalBest]: data.personalBest,
        [comments]: data.comments,
    };

    return {
        types: [SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAILURE],
        promise: () => fetch(formAction, {
            method: 'POST',
            mode: 'no-cors',
            body: stringify(body),
            headers: {
                Accept: 'application/json, application/xml, text/plain, text/html, *.*',
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
        }).then(response => (
            response.text()
        )),
    };
};

export const sendApiFeedback = data => ({
    types: [SEND_API_FEEDBACK, SEND_API_FEEDBACK_SUCCESS, SEND_API_FEEDBACK_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_planover.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            training_experience: trainingExperienceMap[data.planExperience],
            follow_again: data.useInFuture,
            finish_time: data.pleasedWithFinishTime,
            personal_best: data.personalBest,
            comments: data.comments,
        }),
    }).then(res => res.json()),
});

export const changeField = (key, val) => ({
    type: CHANGE_FIELD,
    key,
    val,
});

export const skipFeedback = () => ({
    type: SKIP_FEEDBACK,
});

export function* openNewSignupSaga() {
    yield put(openNewSignupModal());
}

export function* rootSaga() {
    yield takeEvery(SKIP_FEEDBACK, openNewSignupSaga);
    yield takeEvery(SEND_API_FEEDBACK_SUCCESS, openNewSignupSaga);
}



/** WEBPACK FOOTER **
 ** ./src/redux/feedback.js
 **/